document.addEventListener("DOMContentLoaded", function() {
	if(document.querySelector('.intro-elements')){
		function introInit(){
			document.querySelector('.intro-elements').classList.add('_run')
			document.querySelector('.jsSliderIntro').classList.add('_run')
		}
		setTimeout(introInit, 500)
	}
})